<template>
  <div style="width: 100%;height: 600px;">
    <xr-table ref="xrTable" :configure="configure"></xr-table>
  </div>
</template>

<script>
  export default {
    name: "pageSelectUser",
    data (){
      return {
        configure: {
          url: '/web/service?method=tCoreUser_pageSingleSelectList',
          listParam: {
            orgType: '',
            isOrgAuth: '0'
          },
          isShowSearch: true,
          defaultNoLoadData: true,
          isSelectFirst: false,
          pagination: false,
          idField: 'id',
          columns: [
            {
              field: 'radio',
              width: 60,
            },
            {
              field: 'id',
              title: '账号',
              width: 120,
              condition: {
                searchType: 'input',
                searchName: 'idSearch',
                value:''
              },
            },
            {
              field: 'userName',
              title: '用户名称',
              width: 120,
              condition: {
                searchType: 'input',
                searchName: 'userNameSearch',
                value:''
              },
            },
            {
              field: 'orgName',
              title: '所属部门',
              width: 120,
              condition: {
                searchType: 'input',
                searchName: 'orgNameSearch',
                value:''
              },
            }
          ],
          toolbar: [
            {
              text: '确认',
              iconCls: 'wk wk-list2',
              that: this,
              handler: function () {
                this.that.getSelectedValue();
              }
            },
            {
              text: '取消',
              iconCls: 'wk wk-cancel2',
              that: this,
              handler: function () {
                this.that.handleCloseDialog();
              }
            }
          ]
        },
      }
    },
    components: {

    },
    methods: {
      //初始化   ids： 之前选择的记录  orgType：流程类型（metal、electronic、calibration、energy）    isOrgAuth：是否筛选当前用户的权限（）
      init(ids, orgType, isOrgAuth) {
        this.configure.listParam['orgType'] = orgType;
        this.configure.listParam['isOrgAuth'] = isOrgAuth;
        this.$refs.xrTable.getData();
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit('cancelMethod');
      },
      //获取选中的值
      getSelectedValue(){
        let radio_value = this.$refs.xrTable.radio_value;
        let radio_label = '';
        if(this.$refs.xrTable.radio_row){
          radio_label = this.$refs.xrTable.radio_row.userName;
        }
        if(!radio_value){
          alert('请选择！');
          return false;
        }
        this.$emit('confirmMethod',radio_value,radio_label);
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/PageSelect/core/user/userPageSelect.vue